export function subscribe(eventName, handlerFn) {
    const eventHandler = (event) => {
        const eventPayload = event.detail;
        handlerFn(eventPayload);
    };
    window.addEventListener(eventName, eventHandler);
    return () => {
        window.removeEventListener(eventName, eventHandler);
    };
}



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/emitter-subscriber/subscribe.js
// module id = ./node_modules/@celine/passive-tracking/dist/emitter-subscriber/subscribe.js
// module chunks = 0